import React, { Component } from 'react';
import NewHeader from '../header/newheader';
import { Link, useLocation } from 'react-router-dom'

import home from '../assets/Home/home.png'
import crumbarrow from '../assets/Home/right.png'
import location from '../assets/newHome/location.png';
import load from '../assets/loading.gif'
import "./newcontact.css"
import NewFooter from '../footer/newfooter';

import Axios from 'axios';
import { BASE } from '../api/api';


class NewContact extends Component {

    constructor(props) {
        super(props);
        this.state = {
            name: '',
            email: '',
            message: '',
            msgStatus: false,
        };
    }
    fillalert(msg) {
        this.setState({
            fillalert: true,
            filltext: msg ? msg : ''
        })
        setTimeout(
            function () {
                this.setState({
                    fillalert: null,
                    filltext: ''
                })
            }
                .bind(this),
            3000
        );
    }
    clearform() {
        this.setState({
            fname: "",
            lname: "",
            email: "",
            message: ""
        })
    }
    contactForm = e => {
        e.preventDefault();


        document.getElementById("msg-form").reset();

        console.log(this.state.name)
        console.log(this.state.email)
        console.log(this.state.message)
        this.setState({
            load: true
        })

        var data = JSON.stringify({
            "data": {
                "type": "contact_message--contact_form",
                "attributes": {
                    "name": `${this.state.fname} ${this.state.lname}`,
                    "mail": this.state.email,
                    "message": this.state.message,
                    "subject": "CF"
                }
            }
        });

        var config = {
            method: 'post',
            url: BASE + 'jsonapi/contact_message/contact_form',
            headers: {
                'Accept': 'application/vnd.api+json',
                'Content-Type': 'application/vnd.api+json'
            },
            data: data
        };
        const set = this

        Axios(config)
            .then(function (response) {
                console.log(JSON.stringify(response.data));
                set.setState({
                    load: false
                })
                set.fillalert("Message send successfully")
                set.clearform()
            })
            .catch(function (error) {
                set.setState({
                    load: false
                })
                set.fillalert("Something went wrong")
                console.log(error);
            });

    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    render() {
        return (
            <>
                <NewHeader />
                {this.state.load ? <div className='loading'>
                    <img src={load} alt='load' />
                </div> : ''}
                {this.state.fillalert ? <div className={this.state.filltext === 'Message send successfully' ? "fill-alert fill-success" : "fill-alert"}>{this.state.filltext ? this.state.filltext : 'Please enter all mandatory fields'}</div> : ''}
                <div className="formrea contact-page yourwork sub_work">
                    <div className="title-banner"><h1 className="heading-one bold white-text">Contact Us</h1></div>

                    <div className='container'>
                        <div className='top-contents'>
                            <div className="new-crumbs breadcrumbs gray-text"><Link to='/' className='gray-text'><img className='crumb-home' src={home} /> </Link><img className='rightarrow' src={crumbarrow} />Contact Us</div>
                            {/* <TopBar data={'data1'} /> */}
                        </div>
                        <div className='contact-form-title gray-text'>Leave us a message</div>
                        <div className='rows justify-content-between'>
                            <form className='contactUs-form-container' id='msg-form' onSubmit={(e) => this.contactForm(e)}>
                                <input type="text" name="fname" className='body-two contact_name' placeholder='First Name' value={this.state.fname} onChange={e => { this.handleChange(e) }} required />
                                <input type="text" name="lname" className='body-two contact_name' placeholder='Last Name' value={this.state.lname} onChange={e => { this.handleChange(e) }} required />
                                <input type={'email'} name="email" className='contact_name body-two' value={this.state.email} placeholder='Email Address' onChange={e => { this.handleChange(e) }} required />

                                <textarea className='contact_msg body-two' name="message" value={this.state.message} placeholder='Your Message' onChange={e => { this.handleChange(e) }} required></textarea>

                                <button className='contact-send-button' type='submit'>Send</button>
                            </form>
                            <div className='loc-container'>
                                <div className='d-flex contact-add'>
                                    <img src='/contact/loc.png' className='contact-loc' />
                                    <p className='body-two gray-text contact-add-line'>Minaratein Building, Hamad Bin Khalifa University,<br style={{ display: "block" }} /> Education City, Doha, Qatar.</p>
                                </div>
                                <div className='d-flex loc-1 contact-add'>
                                    {/* <img src='/contact/phn.png' className='contact-phn' />
                                    <p className='body-two gray-text contact-add-line '>+234 081-1236-4568</p> */}
                                </div>
                                <div className='d-flex loc-1 contact-add'>
                                    <img src='/contact/mail.png' className='contact-email' />
                                    <p className='body-two gray-text contact-add-line '>contact.ibir@hbku.edu.qa</p>
                                </div>
                                <a href="https://goo.gl/maps/nJLW32EryHMqpdxL9" className='contact-map-container'>
                                    <img src={location} className='contact-map' />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <NewFooter />
            </>
        )
    }

}

export default NewContact;
